import { IAvailableWorkplacesSchema } from 'shared/repositories/coworking/entities/workplaces/AvailableWorkplacesSchema';

export const isPlaceVisible = (place: IAvailableWorkplacesSchema | null | undefined) =>
  Boolean(place && place.count && place.price);
